import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26cf106b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white px-8 md:px-25 py-5.5 flex justify-between fixed top-0 z-50 w-full border-b" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "hidden lg:flex flex-1 lg:ml-20" }
const _hoisted_4 = { class: "flex-1 flex my-auto space-x-10 font-medium" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "flex lg:hidden" }
const _hoisted_7 = {
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "h-8 w-8"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16",
  class: "inline-flex"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12",
  class: "hidden"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = {
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "h-8 w-8"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16",
  class: "hidden"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12",
  class: "inline-flex"
}, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-1 flex-col space-y-10 font-medium mt-10 ml-4" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "mt-auto mx-auto mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CustomImageSelect = _resolveComponent("CustomImageSelect")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "h-14 rounded-full",
            src: _ctx.$t('logo')
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
          return (_openBlock(), _createElementBlock("a", {
            key: section.id,
            class: _normalizeClass([{ 'font-bold selected': section.selected }, "cursor-pointer relative desktop-link"]),
            href: `/#${section.id}`
          }, _toDisplayString(section.text), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_CustomImageSelect, {
          value: _ctx.selectedLanguage,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          items: _ctx.languages,
          "item-text": "text",
          "item-value": "code",
          "item-image": "image"
        }, null, 8, ["value", "items"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "hover:bg-gray-200 my-auto p-2 rounded-md",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSidebar = !_ctx.showSidebar))
      }, [
        _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10, 512)), [
          [_vShow, !_ctx.showSidebar]
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ hidden: !_ctx.showSidebar }, "fixed lg:hidden top-0 bottom-0 right-0 left-0 bg-black opacity-50"]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSidebar = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["lg:hidden fixed transition-all flex flex-col h-screen w-full bg-white right-0 top-0", `${_ctx.showSidebar ? 'max-w-48' : 'max-w-0'}`])
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "button ml-auto mr-4 mt-4",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSidebar = false))
        }, [
          _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_15, 512)), [
            [_vShow, _ctx.showSidebar]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
          return (_openBlock(), _createElementBlock("a", {
            key: section.id,
            class: _normalizeClass([{ 'font-bold selected': section.selected }, "cursor-pointer relative"]),
            href: `/#${section.id}`
          }, _toDisplayString(section.text), 11, _hoisted_17))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_CustomImageSelect, {
          value: _ctx.selectedLanguage,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          "dropdown-position": "top",
          items: _ctx.languages,
          "item-text": "text",
          "item-value": "code",
          "item-image": "image"
        }, null, 8, ["value", "items"])
      ])
    ], 2)
  ]))
}